import { PaperBlock, PaperBlockReq, paperApi } from 'packages/sdks-next/growp'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Render } from './Render'
import { getQuestionsFromBlock } from '../../../utils'
import { EntryComponentsWrapper } from 'packages/theme'
import { debounce } from '@seiue/util'

/**
 * 试卷编辑 - 分数设置
 * @param param - 参数
 * @param param.blocks - 试题块
 * @returns React.ReactNode
 */
export const ScoreSetting: React.FC<{
  blocks: PaperBlock[] | null
}> = ({ blocks }) => {
  const { api: apiUpdateBlock } = paperApi.useUpdateBlock({
    reload: [paperApi.queryBlocks, paperApi.loadPaper, paperApi.queryPapers],
  })

  const onSaveScore = async (blockId: number, payload: PaperBlockReq) => {
    await apiUpdateBlock({
      id: blockId,
      payload,
    })
  }

  const debounceUpdateScore = debounce(onSaveScore, 300)
  const questionBlocks = useMemo(() => getQuestionsFromBlock(blocks), [blocks])

  if (!questionBlocks || !questionBlocks.length) {
    return (
      <Empty>
        <div>暂无题目</div>
      </Empty>
    )
  }

  return (
    <Wrapper>
      <EntryComponentsWrapper>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          {questionBlocks.map((block, index) => (
            <Render
              key={block.id}
              block={block}
              serialNumber={index + 1}
              onUpdateScore={debounceUpdateScore}
            />
          ))}
        </div>
      </EntryComponentsWrapper>
    </Wrapper>
  )
}

const Empty = styled.div`
  width: 100%;
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: ${(props) => props.theme.text._3};
`

const Wrapper = styled.div`
  &&& {
    .ant-input-number-input {
      width: 85px;
      height: 32px;
    }
  }
`
